import { IMpnRequest } from "../../../types/data.interface";
import { CreateMpnState } from "../states/create/data";
import { Predicates } from "../../../libraries/predicates/predicates";
import { generateNodeId } from "../features/mpn-create/mpn-create.helper";
import { withResolvedMoldedMoldIds } from "./resolveMoldedMoldId";
import { toComponentMaterial } from "../../../helpers/material.helper";

export const formatedNonMoldedComponentId = (components: any[]) => {
  return Array.from(
    components.map((c) => {
      if (c.hasOwnProperty("full_objects")) {
        return {
          ...c,
          // @ts-ignore
          mold_id: Predicates.isNotNullAndNotUndefinedAndNotEmpty(c.mold_id) ? String(c.mold_id).padStart(6, "0") : c.mold ?? c.full_objects?.non_mold?.id ?? null,
          mold_description:
            c?.full_objects?.non_mold?.name ?? c.mold_description,
          //@ts-ignore
          color_id: c.full_objects?.non_mold?.color?.id ?? c.color_id,
          //@ts-ignore
          color: c.full_objects?.non_mold?.color,
          //@ts-ignore
          color_description:
            c.full_objects?.non_mold?.color.name ?? c.color_description,
          material_id:
            c.full_objects?.non_mold?.material?.id ?? c.material_id,
          //@ts-ignore
          material: c.full_objects?.non_mold?.material,
          material_description:
            toComponentMaterial(c.full_objects?.non_mold?.material).material_description ?? c.material_description,
          sequence_number:
          //@ts-ignore
          c.full_objects?.non_mold?.sequence_number ?? `${c.sequence_number}`,
          node_id: generateNodeId()
        };
      }

      return {
        ...c,
        // @ts-ignore
        mold_id: Predicates.isNotNullAndNotUndefinedAndNotEmpty(c.mold_id) ? String(c.mold_id).padStart(6, "0") : c.mold,
      };
    }),
  );
};

export const formatMoldedComponents = (components: any[]) =>
  withResolvedMoldedMoldIds(components);

export const mpnRequestDto = (
  mpn: CreateMpnState,
  username: string,
): IMpnRequest => {
  const mpnRequest: IMpnRequest = {
    comments: mpn.mpnData.comments,
    gift_box: mpn.mpnData.giftbox,
    item_description: mpn.mpnData.name,
    production_lifecycle_status: mpn.mpnData.production_lifecycle_status,
    project_id: mpn.mpnData.project_id,
    sales_lifecycle_status: mpn.mpnData.sales_lifecycle_status,
    standard_pack: mpn.mpnData.stdpk,
    std_pk_size_h: mpn.mpnData.stdpk_height,
    std_pk_size_l: mpn.mpnData.stdpk_length,
    std_pk_size_w: mpn.mpnData.stdpk_width,
    std_pk_wgt: mpn.mpnData.stdpk_weight,
    product_use: mpn.mpnData.product_use,
    release_date: mpn.mpnData.reldt,
    prod_dim_h: mpn.mpnData.height,
    prod_dim_l: mpn.mpnData.length,
    prod_dim_w: mpn.mpnData.width,
    pgrwgt: mpn.mpnData.pgrwgt,
    pntwgt: mpn.mpnData.pntwgt,
    cntwgt: mpn.mpnData.cntwgt,
    category: mpn?.category,
    sub_category: mpn?.sub_category,
    product_line: mpn?.product_line,

    tps_product: mpn.mpnData.tps_product,

    //@ts-ignore
    tps_loc_id: Predicates.isNotNullAndNotUndefinedAndNotEmpty(mpn?.mpnData?.tps_loc_id?.id) ? mpn?.mpnData?.tps_loc_id?.id : mpn?.mpnData?.tps_loc_id ,
    //@ts-ignore
    tps_type_id: !!(mpn?.mpnData?.tps_product === "Y")
      ? mpn?.mpnData?.tps_type_id?.res_pis_type_id
      : "",

    id: mpn.mpnRequest.id,
    pis_request_id: mpn.mpnRequest.pis_request_id ?? null,

    //@ts-ignore
    revision: !!mpn.mpnRequest.revision ? Number(mpn.mpnRequest.revision) : 0,

    //@ts-ignore
    res_pm_market: Number(mpn.requestorInfo.id),
    status: mpn.mpnRequest.status,

    sku_composition: JSON.stringify({
      ...mpn.composition,
        molded_components: formatMoldedComponents(mpn.composition.molded_components),
      non_molded_components: formatedNonMoldedComponentId(mpn.composition.non_molded_components),
    }),
    dtchng: new Date().toISOString().split("T")[0],
    request_date: !!mpn.mpnRequest.request_date
      ? mpn.mpnRequest.request_date
      : new Date().toISOString().split("T")[0],
    requested_by: username,

    //@ts-ignore
    finish_goods_no_assigned: mpn.mpnRequest.finish_goods_no_assigned,
    global_product: mpn?.global_product.id,
    assoc_pp_id: 0,
    cloned_sku_id: "",

    //FIXME: PUT HERE THE RIGHT DATA
    similar_skus: undefined,
    tcc: mpn.itemNumber?.id,
    tcc_composition_region: undefined,
    uidchng: "",
    item_number: mpn.itemNumber?.id,
    fusion_supplier: mpn.fusionSupplier?.id
  };

  return mpnRequest;
};
